/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Media_SlotsInputs */

const cs_templates_media_slots = /** @type {(inputs: Templates_Media_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediální sloty`)
};

const en_templates_media_slots = /** @type {(inputs: Templates_Media_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media slots`)
};

/**
* | output |
* | --- |
* | "Media slots" |
*
* @param {Templates_Media_SlotsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_media_slots = /** @type {((inputs?: Templates_Media_SlotsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Media_SlotsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_media_slots(inputs)
	return cs_templates_media_slots(inputs)
});